export default {"src":"/_next/static/image/public/images/flags/flag_211.43b67ed65db5df6c7e1525c40d830bb5.svg","height":16,"width":24};